import type { TOC } from '@ember/component/template-only'
import { type RexStadiumEventsRoute } from 'teacher-ui-client/reporting/ui-scope/rex/stadium-events/route'
import ReportingTeacherUiHeader from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { t } from 'ember-intl'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { array } from '@ember/helper'
import { not } from 'ember-truth-helpers'
import { StadiumEventsTotals } from 'teacher-ui-client/components/giraffe/charts/stadium-events/totals'
import { StadiumEventsHistory } from 'teacher-ui-client/components/giraffe/charts/stadium-events/history'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import RouteTemplate from 'ember-route-template'
import { camelize } from '@ember/string'
import { concat } from '@ember/helper'

interface Signature {
  model: ModelFor<RexStadiumEventsRoute>
}

export const RexStadiumEvents: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.stadiumEvents"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.stadiumEventsTotals}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.rex.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.stadiumEventsTotals}}>
    {{#each @model.stadiumEventsTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <StadiumEventsTotals
          @data={{gradeData}}
          @grade={{fullGradeName gradeData.grade_position}}
          @summaryTitle={{t (concat "reporting.summaryTitles.stadiumEventsTotals." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.stadiumEventsTotals"}}
        />
      </div>
    {{/each}}
    {{#if @model.stadiumEventsHistory}}
      <StadiumEventsHistory
        @data={{@model.stadiumEventsHistory}}
        @students={{@model.scopedStudents}}
        @uiScope={{@model.uiScope.scope}}
        @subco={{(isSubco)}}
        @tooltip={{t "reporting.tooltips.stadiumEventsHistory"}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(RexStadiumEvents)
